import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangePasswordModel } from 'src/app/models/common/change-password-model';
import { BackendListModel } from 'src/app/models/common/list.model';
import { PutTwoFactorAuthModel, TwoFactorAuthModel } from 'src/app/models/common/two-fact-auth-model';
import { AuthService } from 'src/app/services/auth.service';
import { SuccessBoxComponent } from '../../dialog-box/success-box/success-box.component';


@Component({
  selector: 'privacy-n-security',
  templateUrl: './privacy-n-security.component.html',
  styleUrls: ['./privacy-n-security.component.scss']
})
export class PrivacyNSecurityComponent implements OnInit {

  currentDate = new Date();
  passwordChangedDays;
  passwordChangeMessage;

  @ViewChild('passReset')
  passReset!: any;

  message = 'For security reasons, it is required to log in again using your new password.'

  twoFactAuthList: BackendListModel<TwoFactorAuthModel>; // 2-Factor Auth List
  enableTwoFA: PutTwoFactorAuthModel = {
    two_factor_auth: null
  }

  passwordObj: ChangePasswordModel;
  defaultPasswordObj: ChangePasswordModel = {
    old_password: null,
    new_password: null
  }
  new_password_confirm: string;
  errorObject: any = {};
  

  resetPassword() {
    this.passReset.nativeElement.style.left = "0";
  }
  closePassReset(){
    this.passReset.nativeElement.style.left = "100vw";
  }
  resetDone() {
    this.passReset.nativeElement.style.left = "-130vw";
    // console.log(this.passReset.nativeElement.style.left);
    this.passwordObj = { ...this.defaultPasswordObj };
    this.new_password_confirm = null
  }

  authOptions = [
    {
      name: 'Google Authentication',
      details: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima nam tempore, fugit quam similique saepe perspiciatis voluptas sit facere accusamus aliquid ',
      recommended: true
    },
    {
      name: 'Text Message(SMS)',
      details: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima nam tempore, fugit quam similique saepe perspiciatis voluptas sit facere accusamus aliquid ',
      recommended: false
    },
    {
      name: 'Email(Contact Email)',
      details: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima nam tempore, fugit quam similique saepe perspiciatis voluptas sit facere accusamus aliquid ',
      recommended: false
    }
  ];

  constructor(private authService: AuthService, private snackBar: MatSnackBar, private dialog: MatDialog,private elementRef:ElementRef) { }

  ngOnInit(): void {
    this.passwordObj = { ...this.defaultPasswordObj };
    this.getTwoFAList();
    this.getPasswordChangedStatus();
  }

  ngAfterViewInit(){
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      // console.log("this is what I got in event",event)

      if(event.code==="Escape"){
        this.closePassReset();
      }
    });
  }

  // GET 2-FA list
  getTwoFAList() {
    this.authService.getTwoFactAuthList().subscribe({
      next: response => {
        this.twoFactAuthList = response;
      },
      error: error => {
        console.log(error)
        return error;
      }
    });
  }

  //
  update2FA(event) {
    this.enableTwoFA.two_factor_auth = event.id
    this.enable2FactorAuth(event.name)
  }

  // PUT 2-FA
  enable2FactorAuth(snackBarLabel) {
    this.authService.updateTwoFactAuth(this.enableTwoFA).subscribe({
      next: response => {
        this.snackBar.open(`2-FA updated to ${snackBarLabel} successfully!`, 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        return response;
      },
      error: error => {
        this.snackBar.open(`2-FA updation unsuccessful!`, 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        return error;
      }
    });
  }

  // Change Password
  changeUserPassword() {
    if (!this.passwordObj.old_password) {
      this.errorObject = { old_password: ['Please enter current password to continue.'] }
      return;
    }

    if (this.passwordObj.new_password == '' || this.passwordObj.new_password == null) {
      this.errorObject.new_password = ['This field may not be blank.']

      if (this.new_password_confirm == '' || this.new_password_confirm == null) {
        this.errorObject.new_password_confirm = ['This field may not be blank.']
      }
      return;
    }

    if (this.new_password_confirm !== this.passwordObj.new_password) {
      this.errorObject.new_password_confirm.push('Passwords entered do not match.')
      return;
    }

    this.authService.changePassword(this.passwordObj).subscribe({
      next: response => {
        this.errorObject = null
        this.resetDone();
        setTimeout(() => {
          this.openSuccessDialog('Password changed successfully!', `${this.message}`, 'I understand')
        }, 800);
        return response;
      },
      error: error => {
        console.log(error)
        this.errorObject = { ...error.error }
        return error;
      }
    });
  }

  openSuccessDialog(label, temp, action) {
    const dialogRef = this.dialog.open(SuccessBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: label, parent: this, description: temp, label1: action, positiveAction: this.onPasswordChangeSuccess }
    })
    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        this.authService.doLogout();
      }, 600);
    });
  }

  onPasswordChangeSuccess(parent) {
    setTimeout(() => {
      parent.authService.doLogout();
    }, 600);
  }

  getPasswordChangedStatus() {
    this.authService.getPasswordChangedDate().subscribe({
      next: response => {
        if (response.password_changed_at == null) {
          this.passwordChangeMessage = `Never Changed!`;
        } else {
          this.passwordChangedDays = this.getDateDifference(new Date(response.password_changed_at));
          this.passwordChangeMessage = `Last modified ${this.passwordChangedDays} Days ago.`;
        }
      },
      error: error => {
        console.log('password change date error', error)
        return error;
      }
    });
  }

  getDateDifference(date: Date) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    const utc2 = Date.UTC(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  resetOldPasswordError(event) {
    if (event != null) {
      this.errorObject.old_password = []
    }
  }

  resetNewPasswordError(event) {
    if (event != null) {
      this.errorObject.new_password = []
    }
  }

  resetConfirmPasswordError(event) {
    if (event != null) {
      this.errorObject.new_password_confirm = []
    }
  }
}
